// Confidence scores below these thresholds mean the U.S. Postal Service could
// not confirm the address, so saving it has to be authorised with a fresh
// override validation key.
export const DOMESTIC_CONFIDENCE_THRESHOLD = 80;
export const INTERNATIONAL_CONFIDENCE_THRESHOLD = 70;

const DOMESTIC_ADDRESS_TYPES = ['DOMESTIC', 'MILITARY', 'OVERSEAS MILITARY'];

const INTERNATIONAL_ADDRESS_TYPE = 'INTERNATIONAL';

/**
 * Whether the payload needs a new override validation key before it can be
 * saved. An existing key is assumed to already be current, so nothing is
 * fetched for it.
 *
 * Takes the submit payload rather than the address itself, matching the call
 * site in the AddressValidationView class.
 */
export const requiresNewValidationKey = ({
  addressMetaData,
  overrideValidationKey,
} = {}) => {
  if (overrideValidationKey) {
    return false;
  }

  const addressType = addressMetaData?.addressType?.toUpperCase();
  const { confidenceScore } = addressMetaData ?? {};

  if (DOMESTIC_ADDRESS_TYPES.includes(addressType)) {
    return confidenceScore < DOMESTIC_CONFIDENCE_THRESHOLD;
  }

  return (
    addressType === INTERNATIONAL_ADDRESS_TYPE &&
    confidenceScore < INTERNATIONAL_CONFIDENCE_THRESHOLD
  );
};
